module.exports = "/pages/business/hotelslabo/question_q.png";